import React from 'react';
import PropTypes from 'prop-types';
import StarRatingComponent from 'react-star-rating-controlled-component';
import { Field } from 'redux-form';

import { onClickWrapper } from '../../../utils/ui';

class Stars extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: props.initialValue || 0,
    };
  }

  static renderStars = ({
    name,
    value,
    onChange,
    id,
    starCount,
    starColor,
    emptyStarColor,
    renderStarIcon,
    input,
  }) => (
    <StarRatingComponent
      {...{
        starCount,
        starColor,
        emptyStarColor,
        renderStarIcon,
        id,
      }}
      name={name || id}
      onStarClick={onClickWrapper(id, (value) => {
        if (input && input.onChange) {
          input.onChange(value);
        } else if (onChange) {
          onChange(value);
        }
      })}
      value={(input && +input.value) || value || 0}
    />
  );

  onStarClick = (value) => {
    this.setState({
      value,
    });
  };

  render() {
    const {
      name,
      id,
      starCount,
      starColor,
      emptyStarColor,
      renderStarIcon,
    } = this.props;

    const { value } = this.state;

    const customProps = {
      name,
      id,
      starCount,
      starColor,
      emptyStarColor,
      renderStarIcon,
    };

    return name ? (
      <Field
        name={name}
        value={value}
        onChange={this.onStarClick}
        component={Stars.renderStars}
        props={customProps}
      />
    ) : (
      Stars.renderStars(this.props)
    );
  }
}

Stars.propTypes = {
  name: PropTypes.string,
  starCount: PropTypes.number,
  starColor: PropTypes.string,
  emptyStarColor: PropTypes.string,
  renderStarIcon: PropTypes.any,
  id: PropTypes.string,
};

export default Stars;
